import { parseDateValue } from './formatUtils';
const ISO_DATE_ONLY_RE = /^\s*(\d{4})-(\d{2})-(\d{2})\s*$/;
const ISO_DATE_EMBED_RE = /(\d{4})-(\d{2})-(\d{2})/g;

const pad2 = (n) => String(n).padStart(2, '0');

const formatYMDToRu = (year, month, day) => `${pad2(day)}.${pad2(month)}.${year}`;

/**
 * Форматирует дату/дату-диапазон в "русский" вид: `дд.мм.гггг`.
 * Поддерживает:
 * - `YYYY-MM-DD` (одиночная дата)
 * - строки с вхождениями `YYYY-MM-DD` (например `(YYYY-MM-DD - YYYY-MM-DD)`)
 * - Date / timestamp
 */
export const formatRuDate = (value) => {
  if (value === null || value === undefined) return '';

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return '';
    return value.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  if (typeof value === 'number') {
    const d = parseDateValue(value);
    if (!d) return '';
    return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  if (typeof value !== 'string') {
    return '';
  }

  const input = value.trim();
  if (!input) return '';

  const m = input.match(ISO_DATE_ONLY_RE);
  if (m) {
    const [, y, mo, da] = m;
    return formatYMDToRu(y, mo, da);
  }

  // Одиночную дату-время форматируем целиком, диапазоны обрабатываем ниже.
  const d = parseDateValue(input);
  if (d) {
    return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  // Если в строке встречаются ISO даты, заменяем каждую на `дд.мм.гггг`
  if (ISO_DATE_EMBED_RE.test(input)) {
    // reset lastIndex for global regex safety
    ISO_DATE_EMBED_RE.lastIndex = 0;
    return input.replace(ISO_DATE_EMBED_RE, (_, y, mo, da) => formatYMDToRu(y, mo, da));
  }

  return value;
};

/**
 * Форматирует дату-время для отображения: `дд.мм.гггг ...`.
 * Для строк `YYYY-MM-DD` вернёт только дату (без времени).
 */
export const formatRuDateTime = (value) => {
  if (value === null || value === undefined) return '';

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return '';
    return value.toLocaleString('ru-RU');
  }

  if (typeof value === 'number') {
    const d = parseDateValue(value);
    if (!d) return '';
    return d.toLocaleString('ru-RU');
  }

  if (typeof value !== 'string') return '';

  const input = value.trim();
  if (!input) return '';

  // Если это ISO-дата без времени — форматируем только дату
  if (ISO_DATE_ONLY_RE.test(input)) {
    return formatRuDate(input);
  }

  const d = parseDateValue(input);
  if (d) {
    return d.toLocaleString('ru-RU');
  }

  // Если не распарсили — оставляем как есть (но можно попробовать показать только дату)
  return formatRuDate(input);
};

